"use client";
import { CssBaseline, Popper } from "@mui/material";
import { LicenseInfo } from "@mui/x-license";
import { alpha, darken } from "@mui/material";
import { ClickAwayListener } from "@mui/material";
import { SxProps } from "@mui/material";
export type { SxProps as WcSxProps };
export { ClickAwayListener as WcClickAwayListener };
export { CssBaseline, LicenseInfo, alpha, darken };
export * from "./WcModal/WcModal";
export * from "./WcSideSheet/WcSideSheetComponent";
export * from "./WcDialog/WcDialog";
export * from "./WcLocalizationProvider/WcLocalizationProvider";
export * from "./WcAdapterDayjs/WcAdapterDayjs";
export * from "./WcTypes/WcTypes";
export * from "./WcUpdateLocale/WcUpdateLocale";
export * from "./WcTransitions/WcTransitions";
export const WcPopper = Popper;

LicenseInfo.setLicenseKey("2167094a0e47fd879a30e3d04f2a2736Tz0xMjEwMDgsRT0xNzk1MTMyNzk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj0yMDIyLEtWPTI=");
